import { Button, ButtonProps, CircularProgress } from "@mui/material";

export type LoadingButtonProps = ButtonProps & {
  loading?: boolean;
  loadingLabel?: string;
};

export const LoadingButton = ({
  loading = false,
  loadingLabel,
  disabled,
  startIcon,
  children,
  ...buttonProps
}: LoadingButtonProps) => (
  <Button
    {...buttonProps}
    disabled={disabled || loading}
    startIcon={loading ? <CircularProgress color="inherit" size={16} aria-label={loadingLabel || "Cargando"} /> : startIcon}
    aria-busy={loading || undefined}
  >
    {loading && loadingLabel ? loadingLabel : children}
  </Button>
);
